import { apiGet, apiPut } from "@apis/gateway";
import {
  listStatusAction,
  listLocationAction,
} from "@reduxs/Actions/monitoringAction";
import { loadingAction } from "@reduxs/Actions/storeAction";

// Shared monitoring data helpers.
// `getStatus` / `getLocation` were byte-identical in Monitoring.tsx and
// Device.tsx, and the mute-alarm PUT was duplicated across both
// (Monitoring.handleMute / Device.onMute). Centralised here so both pages call
// one source. Each takes `dispatch` + `language` (redux-thunk style — the fetch
// + dispatch pair matches how the pages already work).

export const fetchDeviceStatus = async (dispatch: any, language: string) => {
  const res = await apiGet(
    `${process.env.REACT_APP_API_DOMAIN}/monitoring-api/monitoring/device-status`,
    {},
    language
  );
  if (res.status && res.code === 200) {
    dispatch(
      listStatusAction(
        (res?.data?.data ?? []).filter((e: any) => e?.filterStatus !== "all")
      )
    );
  }
};

export const fetchLocationFilter = async (dispatch: any, language: string) => {
  const res = await apiGet(
    `${process.env.REACT_APP_API_DOMAIN}/monitoring-api/monitoring/location-filter`,
    {},
    language
  );
  if (res.status && res.code === 200) {
    dispatch(listLocationAction(res?.data?.data ?? []));
  }
};

export const muteAlarm = async (
  dispatch: any,
  language: string,
  macAddress = ""
) => {
  dispatch(loadingAction(true));
  await apiPut(
    `${process.env.REACT_APP_API_DOMAIN}/monitoring-api/device/${macAddress}/mute-alarm`,
    {},
    {},
    language
  );
  dispatch(loadingAction(false));
};
